import { getApiConfig } from '../config.js';

export function createXmHeaders(extra?: Record<string, string>): Headers {
  const config = getApiConfig();
  const headers = new Headers(extra);
  headers.set('XM-Device-UDID', config.deviceUdid);
  headers.set('XM-Client-Version', config.clientVersion);
  headers.set('XM-Client-Platform', config.clientPlatform);
  return headers;
}
